import React from "react";
import tableIcon from "../../img/icon_table.svg";

import {
  StyledTableWrapper,
  StyledTableAnchor,
  StyledTableIconStandAlone,
  StyledTableIconStudySummary,
  StyledTableTitle,
  StyledCaption,
} from "./_.styled";

const GenericTable = ({
  setIsDialogOpen,
  setTableData,
  children,
  inlineTable,
  tableText,
  tableCaption,
  isStandAlone = false,
  isRightRails = false,
  withBackground = false,
  tableId = null,
  affordance,
  isNonFreePreview = false,
  handleOpenTable,
}) => {
  tableCaption = tableCaption && ` ${tableCaption}`;
  const tableTestId = tableId ? `-${tableId}` : "";
  const onAnchorClick = (e) => {
    e.preventDefault();
    if (isNonFreePreview) {
      return handleOpenTable();
    }
    setIsDialogOpen(true);
    setTableData({
      title: `${tableText}${tableCaption}`,
      isStandAlone,
      tableId,
      affordance,
      children,
      inlineTable,
    });
  };
  return (
    <>
      <StyledTableWrapper
        data-testid="styled-table-anchor-div"
        id={tableId?.toUpperCase()}
      >
        <StyledTableAnchor
          data-testid={`table-anchor${tableTestId}`}
          isStandAlone={isStandAlone}
          isRightRails={isRightRails}
          withBackground={withBackground}
          onClick={onAnchorClick}
        >
          {isStandAlone ? (
            <>
              <StyledTableIconStandAlone
                src={tableIcon}
                alt="table icon"
                data-testid="table-icon-stand-alone"
              />
              <StyledCaption
                data-testid="table-heading"
                isRightRails={isRightRails}
              >
                {!isRightRails && (
                  <StyledTableTitle data-testid={`table-title${tableTestId}`}>
                    {tableText}
                  </StyledTableTitle>
                )}
                <strong data-testid="table-caption">{tableCaption}</strong>
              </StyledCaption>
            </>
          ) : (
            <>
              <StyledTableIconStudySummary
                icon={{ glyph: "table_chart" }}
                data-testid="table-icon-study-summary"
              />
              <span data-testid={`table-title-study-summary${tableTestId}`}>
                <strong>{tableText}</strong>
                {tableCaption}
              </span>
            </>
          )}
        </StyledTableAnchor>
      </StyledTableWrapper>
    </>
  );
};

export default GenericTable;
